export default {"src":"/_next/static/media/chooseMultipleBankAccounts.3c3588c4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};